import { motion } from "framer-motion";
import React, { useState } from "react";
import { MdOutlineAttachFile } from "react-icons/md";
import theme from "../theme/theme1";

const ImpressiveFacilities = () => {
  const images = [
    "https://velammalnexus.com/wp-content/uploads/2023/10/home-chemistry-lab.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/future-skills.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/ecaypla-2.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/smart-class.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/faclities-image-1.jpg",
    "https://velammalnexus.com/wp-content/uploads/2023/10/smart-class.jpg",
  ];

  const descriptions = [
    "Our state-of-the-art chemistry lab provides an immersive learning experience, equipped with the latest tools and technology to foster scientific discovery and innovation.",
    "Future Skills training program prepares students for the ever-changing job market, equipping them with the skills necessary for success in technology-driven industries.",
    "Our e-learning space is designed to inspire creativity and collaboration, featuring interactive tools and digital resources that make learning more engaging.",
    "Our smart classrooms are equipped with the latest technology, offering a modern and dynamic learning environment that adapts to different teaching styles.",
    "This facility provides ample space for various extracurricular activities, with top-notch infrastructure and safety standards to ensure a productive learning experience.",
    "Smart Classrooms in our campus blend technology and education, creating an interactive learning environment that caters to modern educational needs.",
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleSmallImageClick = (index) => {
    setCurrentImageIndex(index);
  };

  return (



    <section
      className="py-12 px-4 bg-gradient-to-r from-[#b3a369] to-[#f8f4e8] font-sans relative overflow-hidden"
      style={{ fontFamily: theme.fontFamily }}
    >
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="text-5xl font-extrabold text-[#13294b] tracking-wide">
          Experience
        </h2>
        <h3 className="text-3xl font-bold text-[#13294b] mt-4 tracking-wide">
          Our Impressive Facilities
        </h3>
      </motion.div>

      <div className="flex flex-col lg:flex-row items-center lg:justify-center lg:space-x-8 max-w-6xl mx-auto">
        {/* Main Image Section with Hanger-like Animation */}
        <motion.div
          className="w-full lg:w-1/2 h-[400px] lg:h-[500px] relative overflow-hidden mb-8 lg:mb-0"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {/* Hanger Lines */}
          <div className="absolute top-0 left-1/3 right-1/3 h-8 flex justify-center items-center">
            <div className="w-2 h-full bg-gray-600 mr-4"></div>
            <div className="w-2 h-full bg-gray-600 ml-4"></div>
          </div>

          {/* Hanger Icon with Swing Animation */}
          <motion.div
            className="absolute top-8 left-1/2 transform -translate-x-1/2"
            animate={{
              rotate: [0, -5, 5, -5, 0], // Hanger-like swing animation
              transition: { repeat: Infinity, duration: 2, ease: "easeInOut" },
            }}
          >
            <MdOutlineAttachFile className="text-4xl text-[#13294b] animate-pulse" />
          </motion.div>

          {/* Image with Frame, Shadow, and Tilt */}
          <motion.div
            className="absolute inset-0 flex justify-center items-center"
            style={{ transform: "rotate(-2deg)" }}
          >
            <div className="relative w-5/6 h-5/6 border-8 border-gray-800 shadow-lg">
              <motion.img
                src={images[currentImageIndex]}
                alt="Facility Slide"
                className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform hover:scale-110"
                style={{ transformOrigin: "top center" }}
              />
              <div className="absolute inset-0 bg-black opacity-0 hover:opacity-25 transition-opacity duration-300"></div>
            </div>
          </motion.div>

          {/* Shadow Effect */}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-5/6 h-4 bg-gray-900 opacity-30 rounded-sm"></div>
        </motion.div>

        {/* Thumbnail and Button Section */}
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
          {/* Grid of Thumbnails */}
          <div className="grid grid-cols-3 gap-4 mb-6 max-w-md">
            {images.map((img, index) => (
              <motion.div
                key={index}
                className={`cursor-pointer overflow-hidden transition-transform duration-300 ${currentImageIndex === index ? "border-4 border-[#13294b]" : "border"
                  }`}
                onClick={() => handleSmallImageClick(index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <img
                  src={img}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-32 object-cover"
                />
              </motion.div>
            ))}
          </div>

          {/* Description Section */}
          <motion.div
            className="text-center mt-8 px-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-lg text-gray-700 leading-relaxed tracking-wide text-justify">
              {descriptions[currentImageIndex]}
            </p>
          </motion.div>

          {/* Action Button */}
          <motion.button
            className="bg-[#b5a262] text-[#13294b] py-3 px-10 rounded-md hover:bg-[#13294b] hover:text-white transition duration-300 mt-6"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Download Application
          </motion.button>
        </div>
      </div>
    </section>


  );
};

export default ImpressiveFacilities;
